import React from "react";
import { DocumentData, DocumentSnapshot } from "firebase/firestore";
import { FormControl } from "native-base";
import SelectFormInput from "../../form/SelectFormInput.web";
import TextAreaFormInput from "../../form/TextAreaFormInput.web";
import { useProtocolAuthorFieldState } from "../../../hooks/useProtocolAuthorFieldState";

type Props = {
  object: DocumentSnapshot<DocumentData>;
  updateObject: (data: any) => Promise<void>;
};

export default function ProtocolAuthorField({ object, updateObject }: Props) {
  const { options, updateWithSnapshot, protocolAuthorRef } =
    useProtocolAuthorFieldState(object, updateObject);

  return (
    <FormControl mb="1">
      <FormControl.Label>Berichtverfasser</FormControl.Label>
      <SelectFormInput
        fieldPath="protocolAuthorRef"
        placeholder="Berichtverfasser wählen"
        options={options}
        doc={object}
        updateDoc={updateWithSnapshot}
      />
      <TextAreaFormInput
        key={protocolAuthorRef}
        fieldPath="protocolAuthor"
        doc={object}
        updateDoc={updateObject}
      />
    </FormControl>
  );
}
